var map = {
	"./0-points.png": 1542,
	"./10-points.png": 1543,
	"./20-points.png": 1544,
	"./30-points.png": 1545,
	"./40-points.png": 1546,
	"./50-points.png": 1547,
	"./60-points.png": 1548,
	"./70-points.png": 1549,
	"./80-points.png": 1550,
	"./90-points.png": 1551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1541;